document.addEventListener("DOMContentLoaded", () => {

    // Ścieżki dla stg
    // const AI_SEARCH_URL = '/proxy/sport/vertex-ai-search';

    // Ścieżki dla prod
    const AI_SEARCH_URL = 'https://www.wroclaw.pl/sport/vertex-ai-search';

    // Ścieżki dla dev
    // const AI_SEARCH_URL = '/front/proxy/sport/vertex-ai-search';

    const ENABLE_AI_SUMMARY = true;

    const vertexSearchForms = document.querySelectorAll('form[data-guide-search-id][data-engine="vertex"]');
    if (vertexSearchForms.length === 0) return;

    function updateSlotWithAnimation(slotElement, htmlContent) {
        if (!slotElement) return;

        const container = slotElement.closest('.v-results-container');
        const isVisible = container && container.classList.contains('visible');

        if (!isVisible) {
            slotElement.innerHTML = htmlContent || '';
            slotElement.style.height = 'auto';
            return;
        }

        const oldHeight = slotElement.offsetHeight;

        slotElement.style.transition = 'none';
        slotElement.style.height = 'auto';
        slotElement.innerHTML = htmlContent || '';

        const newHeight = slotElement.offsetHeight;

        if (oldHeight === newHeight) return;

        slotElement.style.height = oldHeight + 'px';
        slotElement.style.overflow = 'hidden';
        slotElement.offsetHeight;
        slotElement.style.transition = 'height 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
        slotElement.style.height = newHeight + 'px';

        let cleanedUp = false;
        const cleanup = () => {
            if (cleanedUp) return;
            cleanedUp = true;
            slotElement.style.height = 'auto';
            slotElement.style.overflow = 'visible';
            slotElement.style.transition = 'none';
            slotElement.removeEventListener('transitionend', transitionHandler);
        };

        const transitionHandler = (e) => {
            if (e.propertyName === 'height' && e.target === slotElement) cleanup();
        };

        slotElement.addEventListener('transitionend', transitionHandler);
        setTimeout(cleanup, 450);
    }

    vertexSearchForms.forEach(searchForm => {
        const searchInput = searchForm.querySelector('input[type="search"]');
        const searchBtn = searchForm.querySelector('.c-guideSearch__iconBtn');
        const iconSpan = searchBtn.querySelector('span[aria-hidden="true"]');
        const resultsContainer = searchForm.querySelector('[data-guide-results-id]');
        const location = searchForm.dataset.location;

        resultsContainer.classList.add('v-results-container');

        const adjustPopupHeight = () => {
            if (window.innerWidth > 768) {
                resultsContainer.style.maxHeight = '';
                return;
            }

            const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
            const formRect = searchForm.getBoundingClientRect();
            const availableSpace = viewportHeight - formRect.bottom - 10;
            const finalMaxHeight = Math.max(availableSpace, 120);

            resultsContainer.style.maxHeight = `${finalMaxHeight}px`;
        };

        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', adjustPopupHeight);
            window.visualViewport.addEventListener('scroll', adjustPopupHeight);
        } else {
            window.addEventListener('resize', adjustPopupHeight);
        }

        searchInput.addEventListener('focus', adjustPopupHeight);
        window.addEventListener('scroll', adjustPopupHeight);

        let debounceTimer;
        let activeAbortController = null;

        const showAiDisclaimer = () => {
            if (!resultsContainer.querySelector('.v-main-wrapper')) {
                resultsContainer.innerHTML = `
            <div class="v-main-wrapper">
                <div class="v-main-content">
                    <div id="v-ai-slot" aria-live="polite" aria-atomic="true"></div>
                    <div id="v-links-slot"></div>
                </div>
            </div>
        `;
            }

            const aiSlot = resultsContainer.querySelector('#v-ai-slot');
            const linksSlot = resultsContainer.querySelector('#v-links-slot');

            updateSlotWithAnimation(aiSlot, `
                 <div class="v-ai-disclaimer-box">
                      <p class="v-ai-disclaimer-text">Nie podawaj danych osobowych - wyszukiwarka korzysta z AI.</p>
                 </div>
             `);
            updateSlotWithAnimation(linksSlot, '');
            resultsContainer.classList.add('visible');
            searchInput.setAttribute('aria-expanded', 'true');
        };

        searchInput.addEventListener('focus', () => {
            if (window.innerWidth <= 768) {
                setTimeout(() => {
                    searchForm.scrollIntoView({behavior: 'smooth', block: 'start'});
                }, 400);
            }

            if (searchInput.value.trim().length < 3) {
                showAiDisclaimer();
            }
        });

        searchInput.addEventListener("input", () => {
            const query = searchInput.value.trim();

            if (query.length > 0) {
                iconSpan.classList.remove('icon-search');
                iconSpan.classList.add('icon-close');
                searchBtn.setAttribute('aria-label', 'Wyczyść wyszukiwanie');
            } else {
                iconSpan.classList.add('icon-search');
                iconSpan.classList.remove('icon-close');
                searchBtn.setAttribute('aria-label', 'Wyszukaj');
            }

            clearTimeout(debounceTimer);

            if (activeAbortController) activeAbortController.abort();

            if (query.length < 3) {
                if (document.activeElement === searchInput) {
                    showAiDisclaimer();
                } else {
                    resultsContainer.classList.remove('visible');
                    searchInput.setAttribute('aria-expanded', 'false');
                }
                return;
            }

            debounceTimer = setTimeout(() => {
                resultsContainer.classList.add('visible');
                searchInput.setAttribute('aria-expanded', 'true');
                activeAbortController = new AbortController();
                performSearch(query, resultsContainer, searchInput, activeAbortController);
            }, 600);
        });

        searchBtn.addEventListener('click', (e) => {
            if (document.activeElement === searchInput) return;

            if (searchInput.value.trim().length > 0) {
                e.preventDefault();
                searchInput.value = '';
                searchInput.dispatchEvent(new Event('input'));
                searchInput.focus();
            }
        });

        searchForm.addEventListener('submit', (e) => {
            e.preventDefault();
            searchInput.blur();

            const query = searchInput.value.trim();
            if (query.length < 3) return;

            clearTimeout(debounceTimer);

            if (activeAbortController) activeAbortController.abort();

            resultsContainer.classList.add('visible');
            searchInput.setAttribute('aria-expanded', 'true');
            activeAbortController = new AbortController();

            performSearch(query, resultsContainer, searchInput, activeAbortController);
        });

        setupKeyboardNavigation(searchInput, resultsContainer);
        if (location === "hero") setupHeroAnimation(searchInput);
    });

    renderPromotedQuestions();

    function performSearch(query, container, input, controller) {
        if (!container.querySelector('.v-main-wrapper')) {
            container.innerHTML = `
                <div class="v-main-wrapper">
                    <div class="v-main-content">
                        <div id="v-ai-slot" aria-live="polite" aria-atomic="true"></div>
                        <div id="v-links-slot"></div>
                    </div>
                </div>
            `;
        }

        const aiSlot = container.querySelector('#v-ai-slot');
        const linksSlot = container.querySelector('#v-links-slot');

        updateSlotWithAnimation(linksSlot, `
            <div class="v-loader">
                <div class="v-dots"><div class="v-dot"></div><div class="v-dot"></div><div class="v-dot"></div></div>
            </div>
        `);

        if (ENABLE_AI_SUMMARY) {
            updateSlotWithAnimation(aiSlot, `
                <div class="v-ai-placeholder">
                    <div class="gemini-loader-text" style="padding: 15px; display: flex; align-items: center; gap: 8px; color: #5f6368; font-family: inherit;">
                        <span class="gemini-sparkle-icon">
                            <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 0C12 0 13.5 8 16 10.5C18.5 13 24 13 24 13C24 13 18.5 14 16 16.5C13.5 19 12 24 12 24C12 24 10.5 18 8 15.5C5.5 13 0 13 0 13C0 13 5.5 12 8 9.5C10.5 7 12 0 12 0Z" fill="url(#gemini-gradient-js)"/>
                                <defs>
                                    <linearGradient id="gemini-gradient-js" x1="0" y1="0" x2="24" y2="24" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#3b82f6" /> <stop offset="1" stop-color="#a855f7" />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </span>
                        Generuje odpowiedź...
                    </div>
                </div>
            `);
        } else {
            updateSlotWithAnimation(aiSlot, '');
        }

        fetchCombinedSearch(query, container, aiSlot, linksSlot, input, controller.signal);
    }

    async function fetchCombinedSearch(query, container, aiSlot, linksSlot, input, signal) {
        try {
            const response = await fetch(AI_SEARCH_URL, {
                method: 'POST',
                headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
                body: JSON.stringify({q: query, ai_summary: ENABLE_AI_SUMMARY}),
                signal: signal
            });

            if (!response.ok) throw new Error('Błąd serwera');
            const data = await response.json();

            if (input.value.trim().length < 3) return;

            renderLinksOnly(data.results || [], linksSlot, query);

            if (ENABLE_AI_SUMMARY) {
                if (data.summary) {
                    const formattedSummary = formatAiResponse(data.summary);
                    updateSlotWithAnimation(aiSlot, `
                     <div class="v-ai-summary">
                        ${formattedSummary}
                         <div class="v-ai-disclaimer">
                            Wygenerowane przez AI. Weryfikuj podane informacje.
                         </div>
                     </div>
                    `);
                    setTimeout(() => linkifyCitations(container), 100);
                } else {
                    updateSlotWithAnimation(aiSlot, '');
                }
            }

        } catch (error) {
            if (error.name === 'AbortError') return;
            updateSlotWithAnimation(linksSlot, `<div class="v-info">Błąd pobierania wyników.</div>`);
            if (ENABLE_AI_SUMMARY) {
                updateSlotWithAnimation(aiSlot, '');
            }
        }
    }

    function renderLinksOnly(results, container, query) {
        if (results.length === 0) {
            updateSlotWithAnimation(container, '');
            return;
        }

        const items = results.slice(0, 6).map(item => {
            const titleText = item.title;
            const highlightedTitle = highlightText(titleText, query);
            const extractiveAnswer = item.ai_answer || '';
            const snippetText = (item.snippet && item.snippet !== titleText) ? item.snippet : '';

            return `
                <li class="v-item">
                    <a href="${item.link}" class="v-link c-guideSearch__hintstLink" aria-label="${titleText}">
                        <span class="v-title" aria-hidden="true">${highlightedTitle}</span>
                        ${extractiveAnswer ? `<span class="v-hint v-ai-answer" aria-hidden="true" style="font-weight:700; color:#444; margin-bottom:4px;">${extractiveAnswer}</span>` : ''}
                        ${(!extractiveAnswer && snippetText) ? `<span class="v-hint" aria-hidden="true">${snippetText}</span>` : ''}
                    </a>
                </li>
            `;
        }).join('');

        const headerHtml = `<h2 class="v-links-heading">Źródło:</h2>`;
        const listHtml = `<ul style="padding:0; margin:0; list-style:none;">${items}</ul>`;

        updateSlotWithAnimation(container, headerHtml + listHtml);
    }

    function linkifyCitations(container) {
        if (!container) return;
        const placeholders = container.querySelectorAll('.v-ai-citation-placeholder');
        const links = container.querySelectorAll('.v-item .v-link');

        placeholders.forEach(span => {
            const refIndex = parseInt(span.dataset.ref, 10) - 1;
            if (links[refIndex]) {
                const a = document.createElement('a');
                a.href = links[refIndex].href;
                a.target = '_blank';
                a.className = 'v-ai-citation';
                const linkTitle = links[refIndex].querySelector('.v-title').textContent;
                a.setAttribute('aria-label', `Źródło ${span.dataset.ref}: ${linkTitle}`);
                a.textContent = `[${span.dataset.ref}]`;
                span.replaceWith(a);
            }
        });
    }

    function highlightText(text, query) {
        if (!query || !text) return text;
        const words = query.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").split(" ");
        let highlighted = text;
        words.forEach(word => {
            if (word.length < 2) return;
            const regex = new RegExp(`(${word})`, "gi");
            highlighted = highlighted.replace(regex, '<span class="highlight">$1</span>');
        });
        return highlighted;
    }

    function setupKeyboardNavigation(input, container) {
        document.addEventListener("click", (e) => {
            if (e.target !== input && !container.contains(e.target)) {
                container.classList.remove('visible');
                input.setAttribute('aria-expanded', 'false');
            }
        });

        document.addEventListener("keydown", (e) => {
            if (!container.classList.contains('visible')) return;
            const focusable = Array.from(container.querySelectorAll(".v-link"));
            if (focusable.length === 0) return;

            const index = focusable.indexOf(document.activeElement);

            if (e.key === "ArrowDown") {
                e.preventDefault();
                if (index === -1) focusable[0].focus();
                else (focusable[index + 1] || focusable[0]).focus();
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                if (index <= 0) input.focus();
                else focusable[index - 1].focus();
            } else if (e.key === "Escape") {
                container.classList.remove('visible');
                input.setAttribute('aria-expanded', 'false');
                input.focus();
            }
        });
    }

    function setupHeroAnimation(input) {
        if (input.value) return;
        const texts = ["jak zarejestrować pojazd?", "gdzie wyrobić dowód?", "jak zgłosić dziurę w jezdni?", "jak wymienić prawo jazdy?"];
        let tIdx = 0, cIdx = 0, isDel = false, animTimer;

        function type() {
            const curTxt = texts[tIdx];
            cIdx += isDel ? -1 : 1;
            input.placeholder = `np. ${curTxt.substring(0, cIdx)}`;
            if (!isDel && cIdx === curTxt.length) {
                isDel = true;
                animTimer = setTimeout(type, 2500);
            } else if (isDel && cIdx === 0) {
                isDel = false;
                tIdx = (tIdx + 1) % texts.length;
                animTimer = setTimeout(type, 500);
            } else {
                animTimer = setTimeout(type, isDel ? 70 : 120);
            }
        }

        input.addEventListener("focus", () => clearTimeout(animTimer));
        input.addEventListener("blur", () => {
            if (!input.value) type();
        });
        type();
    }

    function renderPromotedQuestions() {
        const randomQuestions = window.randomQuestions || [];
        const container = document.getElementById('popularSearches');
        if (!container || randomQuestions.length === 0) return;

        const isMobile = window.innerWidth <= 768;
        const listClass = isMobile ? 'c-guideSearch__list v-swipeable-list' : 'c-guideSearch__list';

        let html = `<ul class="${listClass}" style="opacity:0; transition: opacity 0.2s; display:flex; ${isMobile ? 'overflow-x: auto; overflow-y: hidden;' : 'overflow: hidden; flex-wrap: wrap;'}">`;

        randomQuestions.forEach(q => {
            html += `<li><a href="pytanie/${q.alias}" class="c-guideSearch__link">${q.short_title}</a></li>`;
        });
        html += '</ul>';
        container.innerHTML = html;

        const list = container.querySelector('ul');
        if (!list) return;

        setTimeout(() => {
            if (!isMobile) {
                const items = Array.from(list.children);
                if (items.length > 0) {
                    let currentLineTop = items[0].offsetTop;
                    let lines = 1;

                    items.forEach(item => {
                        if (item.offsetTop > currentLineTop + 10) {
                            lines++;
                            currentLineTop = item.offsetTop;
                        }

                        if (lines > 2) {
                            item.remove();
                        }
                    });
                }
            }
            list.style.opacity = '1';
        }, 50);
    }

    function formatAiResponse(text) {
        if (!text) return '';

        let processedText = text.replace(/\s*\[([0-9,\s]+)\]/g, (match, numbersStr) => {
            const numbers = numbersStr.split(',').map(n => n.trim());
            return numbers.map(num => `<span class="v-ai-citation-placeholder" data-ref="${num}">[${num}]</span>`).join('');
        });

        if (processedText.includes('*')) {
            const parts = processedText.split('*');
            const intro = parts[0].trim();
            const items = parts.slice(1);

            let html = '';

            if (intro) {
                html += `<p class="v-ai-text" style="margin-bottom: 8px; font-weight: 500;">${intro}</p>`;
            }

            if (items.length > 0) {
                html += '<ul class="v-ai-list" style="margin: 0; padding-left: 20px; list-style-type: disc;">';
                items.forEach(item => {
                    const cleanItem = item.trim();
                    if (cleanItem) {
                        html += `<li style="margin-bottom: 4px; color: #444;">${cleanItem}</li>`;
                    }
                });
                html += '</ul>';
            }
            return html;
        }

        return `<p class="v-ai-text">${processedText.replace(/\n/g, '<br>')}</p>`;
    }
});